import React, {Component} from 'react'

const BookingInput = ({size = 6, type="text", err, ...inputProps}) => {
    let className = `form-control input-md ${err ? 'iperr': ''}`.trim();
    return (
        <div className={`col-md-${size} relative`}>
            { type === "number" ? 
                <NumberOnlyInput 
                    className={className} 
                    {...inputProps} 
                />
                :
                <input 
                    type={type}
                    className={className} 
                    {...inputProps} 
                />
            }
            {err && <div className="errtxt">{err}</div>}
        </div>
    )
}

export class NumberOnlyInput extends Component {

    preventChar(event){
        if(!(event.charCode >= 48 && event.charCode <= 57)){
            event.preventDefault();
            return;
        }
    }

    render() {
        return (
            <input type="tel"  onKeyPress={(e) => this.preventChar(e)} {...this.props}/>
        )
    }
}


export default BookingInput
